// Inject Cloudinary delivery transforms (auto format + auto quality, sizing) into an
// image URL AT RENDER TIME, so we store the raw secure_url but serve an optimized one.
// Non-Cloudinary or already-transformed URLs are returned untouched.
function withTransform(url, transform) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  // already has an f_/q_/w_ transform segment right after /upload/ — leave it alone
  if (/\/upload\/[^/]*[fqw]_/.test(url)) return url;
  return url.replace("/upload/", `/upload/${transform}/`);
}

export const cloudinaryThumb = (url) =>
  withTransform(url, "w_600,h_400,c_fill,g_auto,f_auto,q_auto");

// c_limit never enlarges past the source, so a small original is shown at its
// own size rather than stretched and soft. The originals on the old site are
// now 404, so what we hold IS the ceiling -- displaying honestly beats blurring.
export const cloudinaryFull = (url) =>
  withTransform(url, "w_1200,c_limit,dpr_auto,f_auto,q_auto:good");

// The featured piece on each index stage: the whole image, never cropped or
// zoomed (Sam, 2026-09-11), sized for a ~430px frame on a 2x screen.
export const cloudinaryStage = (url) =>
  withTransform(url, "w_860,c_limit,f_auto,q_auto:good");

// A landmark plate and its strip of thumbnails sit in FIXED-HEIGHT frames, so
// something has to crop. Letting the browser do it with object-cover crops from
// the dead centre and slices the roof off a house or the top off a doorway
// (Sam, 2026-09-17: "some of these images were cut off").
//
// Cloudinary crops instead, with g_auto, which picks the part of the picture
// that actually matters. Same technique already proven on this account for the
// Scrapbook templates. Sized for a 2x screen.
export const cloudinaryPlate = (url) =>
  withTransform(url, "w_1200,h_780,c_fill,g_auto,f_auto,q_auto:good");

export const cloudinaryPlateThumb = (url) =>
  withTransform(url, "w_400,h_236,c_fill,g_auto,f_auto,q_auto:good");
